// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "d0deef33" + "." + "6f799cb9bfd499e4" + ".js";
};